import moment from 'moment';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { DISPLAY_DATE_FORMAT_LONG, INPUT_DATE_FORMAT_SHORT } from '../../../config/helpers';

const propTypes = exact({
  fromDate: PropTypes.string.isRequired,
  toDate: PropTypes.string.isRequired,
});

function DateRange(props) {
  return (
    <>
      <div className="PackageSummary_date">
        {`${moment(props.fromDate).format(DISPLAY_DATE_FORMAT_LONG)} - ${moment(
          props.toDate
        ).format(DISPLAY_DATE_FORMAT_LONG)}`}
      </div>
      <div className="PackageSummary_date-short">
        {`${moment(props.fromDate).format(INPUT_DATE_FORMAT_SHORT)} - ${moment(props.toDate).format(
          INPUT_DATE_FORMAT_SHORT
        )}`}
      </div>
    </>
  );
}

DateRange.propTypes = propTypes;

export default DateRange;
